import { UserStatusEntity } from '../entities';
import { authResource } from './Auth';
export const UserStatusResource = authResource({
    path: '/UserStatuses/:id',
    schema: UserStatusEntity
});
